import { render, staticRenderFns } from "./PuntPesatgeBales.vue?vue&type=template&id=fd158882&scoped=true"
import script from "./PuntPesatgeBales.vue?vue&type=script&lang=js"
export * from "./PuntPesatgeBales.vue?vue&type=script&lang=js"
import style0 from "./PuntPesatgeBales.vue?vue&type=style&index=0&id=fd158882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd158882",
  null
  
)

export default component.exports